// @flow
import type {SagaIterator} from 'redux-saga';
import {call, select} from 'redux-saga/effects';

import {getCurrentPage} from 'selectors/app/app';
import {sendAnalyticsForHP} from 'sagas/app/sendAnalyticsForHP/sendAnalyticsForHP';
import {getAffId} from 'libs/analytics/affiliate';

import {sendAnalyticsForCategoryPage} from '../sendAnalyticsForCategoryPage/sendAnalyticsForCategoryPage';
import {sendAnalyticsForProduct} from '../sendAnalyticsForProduct/sendAnalyticsForProduct';

/**
 * Send analytics depend on page
 */
export function* sendAnalyticsByPage(): SagaIterator {
    const data = yield select(getCurrentPage);
    const affId = yield call(getAffId);

    switch (data.page) {
        case 'home':
            yield call(sendAnalyticsForHP, data, affId);
            break;
        case 'category':
            yield call(sendAnalyticsForCategoryPage, data.id);
            break;
        case 'product':
            yield call(sendAnalyticsForProduct);
            break;
        default:
            return;
    }
}
